const TYPE_LABELS = { pm: 'PM', calibration: 'Calibration', inspection: 'Inspection', service: 'Service', emergency: 'Emergency' };

export const scheduleCycleLabel = (schedule) => [
  TYPE_LABELS[schedule.type] || schedule.type || 'Maintenance',
  schedule.interval_days ? `every ${schedule.interval_days}d` : '',
  schedule.interval_hours ? `every ${schedule.interval_hours}h` : '',
  schedule.interval_uses ? `every ${schedule.interval_uses}u` : '',
].filter(Boolean).join(' · ');

export const scheduleDescription = (schedule) => String(schedule.notes || '').trim();

export const scheduleOptionLabel = (schedule) => [scheduleDescription(schedule), scheduleCycleLabel(schedule)].filter(Boolean).join(' — ');